import { useCallback, useState } from "react";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import Popup from "../../../components/Popup";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import IGFly from "../../../assets/img/SolutionsIcons/AgilysysIGFly.svg";
import { Header } from "../../../components/Header";
import { useLocation } from "react-router-dom";

const IGFlyFPage = () => {
    const [showVideo, setShowVideo] = useState<boolean>(false);
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const { pathname } = useLocation();
    const altText = () => {
      if (pathname.split("/")[1] === "communities")
        return "resident"
      else
        return "guest"
    }
    const altText2 = () => {
        if (pathname.split("/")[1] === "communities")
          return "residents'"
        else
          return "guest's"
      }
    return(
        <div className="page splash IGFlyFPage">
            <div className="page-title"><img src={IGFly} alt="" /></div>
            <Header />
            <div className="text-blocks">
                <div className="std-text">
                Wherever your diners are, that's where your servers and
your POS need to be. No more running from table to 
terminal and back. IG Fly empowers your staff to do it all on
one device: table-side, outside, popup-side, wherever-side. 
Keep diners happy and servers hustling.{'\n\n'} 
                </div>
                <div className="std-text">
                Boost guest spending with sleek handheld devices that 
facilitate order placement and payment acceptance without
ever leaving your diners. Servers are readily available to 
satisfy diner's immediate requests while providing faster
service.
                </div>
            </div>
            <div className="play-video" onClick={()=>{
                _logEvent('click', "Solutions - IG Fly", "Play Video");
                addFlow("Play Video");
                setShowVideo(true)}}>
                <PlayTriangle />
                Play Video
            </div>
            <img className="img-1" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/IGFly1.png"} alt="" />
            <Popup showPopup={showVideo} setShowPopup={()=>setShowVideo(false)} disableOffClick={true}>
                <>{showVideo && <video 
                autoPlay
                controls
                src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/InteractiveIGFly2.mp4"} />}</>
            </Popup>
        </div>
    )
}

export default IGFlyFPage;